import React from "react";
import styled from "styled-components";

const Wrap = styled.div`
    background-color: #fff;
`;

const Container = styled.div`
    margin: 0;
    padding: 30px 15px;
    max-width: 900px;
    margin: 0 auto;

    display: flex;
    justify-content: center;

    @media screen and (max-width: 700px) {
        flex-direction: column;
    }
`;

const Description = styled.div`
    margin-right: 40px;

    @media screen and (max-width: 700px) {
        margin-right: 0;
    }

`;

const Praise = styled.div`
    min-width: 300px;
`;

const Testimonial = styled.div`
    background-color: #ff7a57;
    padding: 20px;
    border-radius: 10px;
    margin: 10px 0;
    color: #fff;

    &:first-child {
        margin-top: 0;
    }

    &:last-child {
        margin-bottom: 0;
    }
`;

const TestimonialName = styled.h3`
    margin: 0;
    font-size: 1.3rem;
`;
const TestimonialSubName = styled.h4`
    margin: 0 0 5px;
    font-size: 1rem;
`;
const TestimonialText = styled.p`
    margin: 0;
    font-size: 1rem;
    line-height: 1.3em;
`;

const About = ({ text }) => {
    return (
        <Wrap>
            <Container>
                <Description>
                    <h2>{text.aboutHeading}</h2>
                    {text.aboutText}
                </Description>
                <Praise>
                    <h2>{text.praiseHeading}</h2>
                    <Testimonial>
                        <TestimonialName>{text.quoteOneHeading}</TestimonialName>
                        <TestimonialSubName>{text.quoteOneSubheading}</TestimonialSubName>
                        <TestimonialText>{text.quoteOneText}</TestimonialText>
                    </Testimonial>
                    <Testimonial>
                        <TestimonialName>{text.quoteTwoHeading}</TestimonialName>
                        <TestimonialSubName>{text.quoteTwoSubheading}</TestimonialSubName>
                        <TestimonialText>{text.quoteTwoText}</TestimonialText>
                    </Testimonial>
                    <Testimonial>
                        <TestimonialName>{text.quoteThreeHeading}</TestimonialName>
                        <TestimonialSubName>{text.quoteThreeSubheading}</TestimonialSubName>
                        <TestimonialText>{text.quoteThreeText}</TestimonialText>
                    </Testimonial>
                </Praise>
            </Container>
        </Wrap>
    );
};

export default About;
